import * as React from "react";
import "./TableInfo.css";

import Dropdown from "./Dropdown";
import MyTabs from "./Tabs";
import GroupButtons from "./GroupButtons";
import { useSelector } from "react-redux";
import TransferList from "../../TableContainer/TransferList"

function TableInfo() {
  const isLoading = useSelector((state) => state.isLoading);

  return (
  
    
    <div className="Table-Title">
      <div>
        <MyTabs />
      </div>
      <div>
        <Dropdown  />
      </div>
      <div className="TransferList_GrpBtn">
      <div >
        {/* <TransferList /> */}
      </div>
 
      <div >
        <GroupButtons />
      </div>
      </div>
    </div>
  );
}

export default TableInfo;
